import axiosAPI from '../utils/axios';
import {
  PendingRecommendationsResponse,
  HistoryRecommendationsResponse,
  ActionResponse,
} from '../@types/ai';
import { OneAdvertiserT } from '../@types/advertiser';

const BASE_URL = '/ai/recommendations/';
const ADMIN_BASE_URL = '/ai/recommendations/admin';

export const aiApi = {
  getPending: async (): Promise<PendingRecommendationsResponse> => {
    const response = await axiosAPI.get<PendingRecommendationsResponse>(
      `${BASE_URL}?filter=pending`
    );
    // @ts-ignore
    return response.data.data;
  },

  getHistory: async (): Promise<HistoryRecommendationsResponse> => {
    const response = await axiosAPI.get<HistoryRecommendationsResponse>(
      `${BASE_URL}history?limit=7`
    );
    return response.data;
  },

  markAsRead: async (actionId: string): Promise<ActionResponse> => {
    const response = await axiosAPI.post<ActionResponse>(`${BASE_URL}/read`, { actionId });
    return response.data;
  },

  dismissAction: async (actionId: string): Promise<ActionResponse> => {
    const response = await axiosAPI.post<ActionResponse>(`${BASE_URL}/dismiss`, { actionId });
    return response.data;
  },

  applyAction: async (actionId: string): Promise<ActionResponse> => {
    const response = await axiosAPI.post<ActionResponse>(`${BASE_URL}/apply`, { actionId });
    return response.data;
  },

  getAdvertisers: async (): Promise<OneAdvertiserT[]> => {
    const response = await axiosAPI.get<OneAdvertiserT[]>('/advertisers/all');
    // @ts-ignore
    return response.data.result;
  },

  getAdminRecommendations: async (
    advertiserId: string,
    date?: string
  ): Promise<HistoryRecommendationsResponse> => {
    const url = date
      ? `${ADMIN_BASE_URL}/${advertiserId}?date=${date}`
      : `${ADMIN_BASE_URL}/${advertiserId}`;
    const response = await axiosAPI.get<HistoryRecommendationsResponse>(url);
    return response.data;
  },

  generateAdminRecommendations: async (advertiserId: string): Promise<ActionResponse> => {
    const response = await axiosAPI.post<ActionResponse>(
      `${ADMIN_BASE_URL}/${advertiserId}/generate`
    );
    return response.data;
  },
};
